module.exports = __webpack_public_path__ + "img/擦汗.b65dba32.gif";